import { booleanAttribute, Component, Input, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { PageComponent } from '../page/page.component';

@Component({
  selector: 'crowdctrl-form-page',
  standalone: true,
  imports: [PageComponent],
  template: `
    <crowdctrl-page
      [pageTitle]="pageTitle"
      [defaultHref]="defaultHref"
      [backButtonIcon]="backButtonIcon"
      [backButtonDisabled]="backButtonDisabled"
      [toolbarBusy]="toolbarBusy"
      [showRefresh]="showRefresh"
      [showHeader]="showHeader"
      [showFooter]="showFooter"
      [footerText]="footerText"
      [loadFn]="loadFn"
      [refreshFn]="refreshFn"
      [toolbarColor]="toolbarColor"
      [progressBarColor]="progressBarColor"
      [enablePwaPullRefresh]="enablePwaPullRefresh"
      contentClass="ion-padding"
    >
      <ng-content></ng-content>
    </crowdctrl-page>
  `,
})
export class FormPageComponent {
  @ViewChild(PageComponent) private inner?: PageComponent;
  @Input() pageTitle = '';
  @Input() defaultHref: string | null = null;
  @Input({ transform: booleanAttribute }) backButtonDisabled = false;
  /** See {@link PageComponent#toolbarBusy}. */
  @Input({ transform: booleanAttribute }) toolbarBusy = false;
  @Input() backButtonIcon?: string;
  @Input() showRefresh = false;
  @Input() showHeader = true;
  @Input() showFooter: boolean | null = null;
  @Input() footerText: string | null = null;
  @Input() loadFn?: () => Observable<unknown>;
  @Input() refreshFn?: () => Observable<unknown>;
  @Input() toolbarColor?: string;
  @Input() progressBarColor = 'medium';
  @Input() enablePwaPullRefresh = false;

  onRefresh(force = false): void {
    this.inner?.onRefresh(force);
  }
}
